'use client';

import {
  HowYourPlanWorks,
  HowYourPlanWorksCardType,
} from '@monetization/hpaip-components-library';
import { useTranslation } from 'react-i18next';
import { NamespacesI18n } from '@storefront/i18n';
import { buildPath } from '@storefront/utils/utils';

export const HowYourPlanWorksV2 = () => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG, {
    keyPrefix: 'howYourPlanWorksV2',
  });
  const planInformations: HowYourPlanWorksCardType[] = t('cards', {
    returnObjects: true,
  });

  const cards = planInformations.map((plan) => ({
    ...plan,
    image: {
      ...plan.image,
      src: buildPath(plan.image.src),
    },
  }));

  return (
    <div>
      <HowYourPlanWorks title={t('title')} cards={cards} />
    </div>
  );
};
